(function ($) {
		
	$(".multiple-cta-band").each(function (index, element) {

		let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		let slideCount = $(element).find(".slide").length;
		let enableSlider = false;

		if( vw >= 1900 && slideCount > 5 ){
			enableSlider = true;
		} else if( vw > 1200 && vw <= 1600 && slideCount > 4 ){
			enableSlider = true;
		} else if( vw > 1130 && vw <= 1200 && slideCount > 3 ){
			enableSlider = true;
		} else if( vw > 640 && vw <= 1130 && slideCount > 2 ){
			enableSlider = true;
		} else if( vw <= 640 && slideCount > 1 ){
			enableSlider = true;
		}

		if ( enableSlider ) {

			let items = $(element).find('.wrapper').toArray();
			let pageWrapper = $('#page-wrapper')[0];

			items.forEach((container, i) => {
				let localItems = container.querySelectorAll(".slide"),
						distance = () => {
							let lastItemBounds = localItems[localItems.length-1].getBoundingClientRect(),
									containerBounds = container.getBoundingClientRect();
							return Math.max(0, lastItemBounds.right - containerBounds.right);
						};
				gsap.to(container, {
					x: () => -distance(), // make sure it dynamically calculates things so that it adjusts to resizes
					ease: "none",
					scrollTrigger: {
						trigger: container,
						start: "+" + $('.site-header').height() + " center", // offset from center using fixed header height
						pinnedContainer: pageWrapper,
						end: () => "+=" + distance(),
						pin: pageWrapper,
						scrub: true,
						invalidateOnRefresh: true // will recalculate any function-based tween values on resize/refresh (making it responsive)
					}
				})
			});

		} else {
			$(element).addClass("disabled");
		}
	});

})(jQuery);